import { useState, useRef } from 'react';
import { AlertTimeIcon, CloseIcon } from '../';
import { daysBetweenDates, reminderTagClassName, getCardTagText } from '../../utils';
import moment from 'moment';

function AlwaysVisibleCardTag(props) {
  const {
    completed,
    reminder_in_day,
    due_date,
    diff_in_day,
    className,
    past_due,
    can_access_content
  } = props;

  return (
    <div className={`tag ${className} ${reminderTagClassName(past_due ? -1 : diff_in_day, completed)}`}>
      <div className="d-flex align-items-center h-100">
        <div className='d-flex align-items-center'>
          <AlertTimeIcon />
          <span>{getCardTagText(past_due ? -1 : diff_in_day, completed)}</span>
        </div>
        {
            completed && can_access_content && 
            <button className="btn btn-link p-0 remove-complete-btn m-0 align-items-center">
              <CloseIcon height={16} width={16} className='m-0'/>
            </button>
          }
      </div>
    </div>
  );
}

export { AlwaysVisibleCardTag };
